import {
  ApplicationConfig,
  provideExperimentalZonelessChangeDetection,
  importProvidersFrom,
  provideAppInitializer,
  inject,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { AppTranslateLoaderFactoryService } from './services/translate';
import { MsalModule, MsalService } from '@azure/msal-angular';
import { MSAL_PROVIDERS, msalInitializer } from './config/msal/msal.config';
import { spinnerInterceptor } from './config/spinner/spinner.interceptor';
import { SnackbarService } from './services/snackbar/snackbar.service';

// This file is part of the Angular application configuration.
export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      const msalService = inject(MsalService);
      return msalInitializer(msalService)();
    }),
    provideHttpClient(
      withInterceptors([spinnerInterceptor]),
      withInterceptorsFromDi(),
    ),
    provideExperimentalZonelessChangeDetection(),
    provideRouter(routes),
    // Provide the TranslateLoader using the factory service
    importProvidersFrom(
      [
        TranslateModule.forRoot({
          loader: {
            provide: TranslateLoader,
            useFactory: (http: HttpClient) =>
              new AppTranslateLoaderFactoryService(
                http,
                inject(SnackbarService),
              ),
            deps: [HttpClient],
          },
        }),
      ],
      MsalModule,
    ),
    MSAL_PROVIDERS.INSTANCE,
    MSAL_PROVIDERS.GUARD_CONFIG,
    MSAL_PROVIDERS.INTERCEPTOR_CONFIG,
    MSAL_PROVIDERS.INTERCEPTOR,
    ...MSAL_PROVIDERS.MSAL_SERVICE,
  ],
};
